function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { StyledProductsMenuComponent } from "./products-menu-component.scss";
import MenuDivider from "../components/menu-divider/menu-divider";
import { PLATFORM_MINI_LINKS, PRODUCTS_LINKS } from "./consts";
import DescriptiveLinkBlock from "../components/descriptive-link-block/descriptive-link-block";
import MiniLinkItem from "../components/mini-link-item/mini-link-item";
import classnames from "classnames";
import { LocalizedProductsHeaderLinks } from "constants/localized-links";
const ProductsMenuComponent = ({ translate, menuId, onLinkClick, localeId })=>{
    const onLinkClickWithMenuId = (event, link, text)=>onLinkClick({
            menuId,
            link,
            event,
            text
        });
    const LOCALIZED_PRODUCTS_LINKS = PRODUCTS_LINKS.map((linkObject)=>{
        var _LocalizedProductsHeaderLinks_localeId;
        return _object_spread_props(_object_spread({}, linkObject), {
            link: ((_LocalizedProductsHeaderLinks_localeId = LocalizedProductsHeaderLinks[localeId]) === null || _LocalizedProductsHeaderLinks_localeId === void 0 ? void 0 : _LocalizedProductsHeaderLinks_localeId[linkObject.title]) || linkObject.link
        });
    });
    return /*#__PURE__*/ _jsxs(StyledProductsMenuComponent, {
        className: "menu-component",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "platform-section",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: classnames("section-title", "align-to-link"),
                        children: translate("header.tabs.products.title.platform")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "links-container",
                        children: PLATFORM_MINI_LINKS.map((_param, index)=>{
                            var { text, link } = _param, platformProps = _object_without_properties(_param, [
                                "text",
                                "link"
                            ]);
                            return /*#__PURE__*/ _createElement(MiniLinkItem, _object_spread_props(_object_spread({
                                link: link,
                                onClick: (event)=>onLinkClickWithMenuId(event, link, text)
                            }, platformProps), {
                                text: translate(text),
                                key: index
                            }));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MenuDivider, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "products-section",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: classnames("section-title", "align-to-link"),
                        children: translate("header.tabs.products.title.products")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "products-container",
                        children: LOCALIZED_PRODUCTS_LINKS.map((_param, index)=>{
                            var { title, link, description } = _param, productProps = _object_without_properties(_param, [
                                "title",
                                "link",
                                "description"
                            ]);
                            return /*#__PURE__*/ _createElement(DescriptiveLinkBlock, _object_spread_props(_object_spread({}, productProps), {
                                link: link,
                                onClick: (event)=>onLinkClickWithMenuId(event, link, title),
                                title: translate(title),
                                description: translate(description),
                                key: index
                            }));
                        })
                    })
                ]
            })
        ]
    });
};
export default ProductsMenuComponent;
